import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * AppLayout - Global layout wrapper
 * 
 * Uses CSS Grid for layout (defined in App.css):
 * - Row 1: Header (auto height)
 * - Row 2: Content (fills remaining space)
 * 
 * This component handles:
 * - Scroll-to-top on route change
 */
export default function AppLayout({ children }) {
  const location = useLocation();

  // Scroll to top on route change - use instant behavior for immediate scroll
  useEffect(() => {
    // Scroll both window and any scrollable containers to top
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    // Also reset any overflow-auto containers
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname]);

  return (
    <div className="app-layout">
      {children}
    </div>
  );
}

